<template lang="html">
    <div class="sms-broadcast-statistics">
        <h4 class="section-title">
            {{ $options.MESSAGE_CONSTANTS.PERFORMANCE }}
        </h4>

        <div class="statistic-row">
            <sms-broadcast-statistic
                class="delivered"
                :label="$options.MESSAGE_CONSTANTS.DELIVERED"
                :value="delivered"
                :description1="$options.MESSAGE_CONSTANTS.DELIVERED_DESCRIPTION.ONE"
                :description2="$options.MESSAGE_CONSTANTS.DELIVERED_DESCRIPTION.TWO"
                :description3="$options.MESSAGE_CONSTANTS.DELIVERED_DESCRIPTION.THREE"
            />

            <sms-broadcast-statistic
                class="failed"
                :label="$options.MESSAGE_CONSTANTS.FAILED"
                :value="failed"
                :description1="$options.MESSAGE_CONSTANTS.FAILED_DESCRIPTION.ONE"
                :description2="$options.MESSAGE_CONSTANTS.FAILED_DESCRIPTION.TWO"
                :description3="$options.MESSAGE_CONSTANTS.FAILED_DESCRIPTION.THREE"
            />

            <sms-broadcast-statistic
                class="pending-opt-in"
                :label="$options.MESSAGE_CONSTANTS.PENDING_OPT_IN"
                :value="pendingOptIn"
                :description1="$options.MESSAGE_CONSTANTS.PENDING_OPT_IN_DESCRIPTION.ONE"
                :description2="$options.MESSAGE_CONSTANTS.PENDING_OPT_IN_DESCRIPTION.TWO"
                :description3="$options.MESSAGE_CONSTANTS.PENDING_OPT_IN_DESCRIPTION.THREE"
            />

            <sms-broadcast-statistic
                class="unsubscribed"
                :label="$options.MESSAGE_CONSTANTS.UNSUBSCRIBED"
                :value="unsubscribed"
                :description1="$options.MESSAGE_CONSTANTS.UNSUBSCRIBED_DESCRIPTION.ONE"
                :description2="$options.MESSAGE_CONSTANTS.UNSUBSCRIBED_DESCRIPTION.TWO"
                :description3="$options.MESSAGE_CONSTANTS.UNSUBSCRIBED_DESCRIPTION.THREE"
            />
        </div>

        <div v-if="status === STOPPED_STATUS" class="summary-row statistic-row">
            <sms-broadcast-statistic
                class="stopped"
                :label="$options.MESSAGE_CONSTANTS.STOPPED"
                :value="stopped"
                :description1="$options.MESSAGE_CONSTANTS.STOPPED_DESCRIPTION.ONE"
                :description2="$options.MESSAGE_CONSTANTS.STOPPED_DESCRIPTION.TWO"
                :description3="$options.MESSAGE_CONSTANTS.STOPPED_DESCRIPTION.THREE"
            />
        </div>
    </div>
</template>

<script>
import { SMS_BROADCAST_STATUS } from '../constants/smsBroadcast.constants';
import SmsBroadcastStatistic from '@/components/broadcast/sms/SmsBroadcastStatistic';
import { getStatisticValueText } from '../utils/smsBroadcast.util';

export const MESSAGE_CONSTANTS = {
    DELIVERED: 'Successfully sent',
    DELIVERED_DESCRIPTION: {
        ONE: 'These messages were',
        TWO: 'successfully sent',
        THREE: 'to the carriers.',
    },
    FAILED: 'Failed to send',
    FAILED_DESCRIPTION: {
        ONE: 'These messages',
        TWO: 'failed to send.',
        THREE: 'This is usually because the number isn\'t valid or it\'s a landline. You\'re not charged for these messages.',
    },
    PENDING_OPT_IN: 'Pending opt-in',
    PENDING_OPT_IN_DESCRIPTION: {
        ONE: 'These messages were sent but are',
        TWO: 'waiting for your recipient',
        THREE: 'to opt in by replying YES.',
    },
    PERFORMANCE: 'Performance',
    STOPPED: 'Stopped',
    STOPPED_DESCRIPTION: {
        ONE: 'These messages were not sent because',
        TWO: 'you stopped',
        THREE: 'the broadcast.',
    },
    UNSUBSCRIBED: 'Unsubscribed',
    UNSUBSCRIBED_DESCRIPTION: {
        ONE: 'These contacts',
        TWO: 'replied STOP',
        THREE: 'after receiving this broadcast.',
    },
};

export default {

    getStatisticValueText,
    SMS_BROADCAST_STATUS,
    MESSAGE_CONSTANTS,

    components: {
        SmsBroadcastStatistic,
    },

    props: {
        status: String,

        statistics: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            STOPPED_STATUS: SMS_BROADCAST_STATUS.STOPPED,
        };
    },

    computed: {
        delivered() {
            const { sent = 0, total = 0 } = this.statistics;

            return getStatisticValueText(sent, total);
        },

        failed() {
            const { failed = 0, total = 0 } = this.statistics;

            return getStatisticValueText(failed, total);
        },

        pendingOptIn() {
            const { pendingOptIn = 0, total = 0 } = this.statistics;

            return getStatisticValueText(pendingOptIn, total);
        },

        stopped() {
            const { stopped = 0, total = 0 } = this.statistics;

            return getStatisticValueText(stopped, total);
        },

        unsubscribed() {
            const { unsubscribed = 0, total = 0 } = this.statistics;

            return getStatisticValueText(unsubscribed, total);
        },
    },
};
</script>

<style lang="scss">
    div.sms-broadcast-statistics {
        padding-top: .7rem;
    }

    div.sms-broadcast-statistics .statistic-row {
        flex-direction: row;
        display: flex;
    }
</style>
